import Vue from 'vue'

import {
  LinkButton,
  Icon,
  CorpButton as Button,
  FormField
} from 'repsol-uikit'

// - Other components
import SectionTitle from 'components/section-title/SectionTitle'
import CognitiveMessage from 'components/cognitive-message/CognitiveMessage'
import PromotionMessageValidation from 'components/promotion-message-validation/PromotionMessageValidation'
import Spinner from 'components/spinner/Spinner'

// - components - registration
Vue.component('ButtonComponent', Button)
Vue.component('IconComponent', Icon)
Vue.component('LinkButton', LinkButton)
Vue.component('FormField', FormField)
Vue.component('SectionTitle', SectionTitle)
Vue.component('CognitiveMessage', CognitiveMessage)
Vue.component('PromotionMessageValidation', PromotionMessageValidation)
Vue.component('Spinner', Spinner)
